import type { InputHTMLAttributes, ReactNode } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode;
  help?: ReactNode;
  error?: ReactNode;
};

export function Input({ label, help, error, className = "", id, ...rest }: Props) {
  return (
    <label className="block" htmlFor={id}>
      {label && <div className="mef-small-caption mb-0.5">{label}</div>}
      <input
        id={id}
        {...rest}
        className={[
          "w-full px-3 py-2.5 bg-mef-subtle text-black/80 rounded-xs",
          "border-[1.2px] outline-none transition-colors",
          error ? "border-mef-red" : "border-mef-gray focus:border-mef-green",
          className,
        ].join(" ")}
      />
      {help && !error && (
        <div className="mt-1 text-[11px] leading-4 text-black/40">{help}</div>
      )}
      {error && (
        <div className="mt-1 text-[11px] leading-4 text-mef-red">{error}</div>
      )}
    </label>
  );
}
